<template>
  <b-card
    class="complaint"
  >
    <table class="props-compact">
      <tr>
        <th>Club</th>
        <td>
          <club-link :clubId="complaint.clubId" />
        </td>
      </tr>
      <tr>
        <th>Reporter</th>
        <td>
          <player-link :playerId="complaint.reporterId" />
        </td>
      </tr>
      <tr>
        <th>Reported</th>
        <td>
          {{complaint.ctime | getMomentStr}}
        </td>
      </tr>
    </table>

    <b-card-text>
      <span
        v-b-popover.hover.top="'Message publication time'"
      >
        {{complaint.msgCtime | getMomentStr}}
      </span>
      <br>
      {{complaint.msgText}}
    </b-card-text>
  </b-card>
</template>

<script>
import ClubLink from './ClubLink.vue';
import PlayerLink from './PlayerLink.vue';

export default {
  name: 'PlayerChatBlockComplaint',

  components: {
    ClubLink,
    PlayerLink,
  },

  props: {
    complaint: {
      type: Object,
      required: true,
    }
  },
};
</script>

<style scoped>
  .card {
    margin-bottom: 2rem;
  }

  .complaint .card-body {
    padding: 8px;
  }

  .complaint table {
    margin-bottom: 1rem;
  }
</style>
